module.exports = __webpack_public_path__ + "static/media/tdsat_icon.632799b2.svg";